import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { createColumn } from "@/lib/table/columnFactory";
import type { LeaveRequest } from "./types";

export const typeColumn = createColumn<LeaveRequest>({
  accessorKey: "type",
  header: ({ column }) => <DataTableColumnHeader column={column} title="Type" />,
  cell: ({ row }) => <span className="font-medium">{row.original.type}</span>,
});
